import React, { Component, PropTypes } from 'react';
import { CourseStore } from 'stores';
import { CourseActions } from 'actions';
import { mixin, RefluxMixin } from 'Util';
import { Loader } from 'components/Material/Loader';
import { TableOfContents } from './TableOfContents';

export default class TableOfContentsContainer extends mixin(
  RefluxMixin,
  Component
) {
  static displayName = 'TableOfContentsContainer';

  static propTypes = {
    ownerSlug: PropTypes.string,
    courseSlug: PropTypes.string
  };

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  listenToStores() {
    this.listenToStore(CourseStore);
  }

  shouldComponentUpdate(nextProps) {
    return this.props !== nextProps;
  }

  componentWillMount() {
    const { ownerSlug, courseSlug } = this.props;
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    CourseActions.findBySlug(ownerSlug, courseSlug);
  }

  render() {
    if (!this.state.course) {
      return <Loader />;
    }
    return (
      <TableOfContents
        course={this.state.course}
        {...this.props}
        canEdit={this.state.course.canEdit}
        editor={this.props.editor && this.state.course.canEdit}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Course/TableOfContentsContainer.js